import React from 'react';

export const SiteContext = React.createContext({
    basePath: '',
    publisher: '',
    fbPixelId: ''
});